import { initSentry } from "../sentry-react.config";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { App } from "./App";

initSentry(`web-app`);

// biome-ignore lint/style/noNonNullAssertion: <root element is guaranteed to be in the document>
const root = ReactDOM.createRoot(document.getElementById("root")!, {
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.warn("Uncaught error", error, errorInfo.componentStack);
	}),
	onCaughtError: Sentry.reactErrorHandler(),
	onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);
